import '@babel/polyfill';
import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import MainContext from './MainContext';
import ErrorBoundary from './ErrorBoundary';
import ConfirmationModal from './confirmationModal';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const AppWrapper = () => {
    const [showModal, setShowModal] = useState(false);
    const [registration, setRegistration] = useState(null);

    const handleUpdate = (registration) => {
      setShowModal(true);
      setRegistration(registration);
    };

    const handleConfirm = () => {
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      setShowModal(false);
    };

    const handleCancel = () => {
      setShowModal(false);
    };

    return (
      <GoogleOAuthProvider clientId='835944366773-2998crgp8lqqd3haom8bp550pdco9kf0.apps.googleusercontent.com'>
        <React.StrictMode>
          <MainContext>
            <ErrorBoundary>
              <App />
              {showModal && (
                <ConfirmationModal
                  message="New version available. Refresh to update?"
                  onConfirm={handleConfirm}
                  onCancel={handleCancel}
                />
              )}
            </ErrorBoundary>
          </MainContext>
        </React.StrictMode>
      </GoogleOAuthProvider>
    );
  };

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<AppWrapper />);

  // Register Firebase service worker for notifications and caching
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/'
      })
      .then((registration) => {
        console.log('✅ Firebase service worker registered successfully:', registration);
      })
      .catch((error) => {
        console.error('❌ Firebase service worker registration failed:', error);
      });
    });
  }
